import { render, staticRenderFns } from "./Step_Pay.vue?vue&type=template&id=4ed65c4c&scoped=true&"
import script from "./Step_Pay.vue?vue&type=script&lang=js&"
export * from "./Step_Pay.vue?vue&type=script&lang=js&"
import style0 from "./Step_Pay.vue?vue&type=style&index=0&id=4ed65c4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed65c4c",
  null
  
)

export default component.exports